export enum AssignmentGroup {
  PayoutMinor = 'Payout Minor',
  PolicyManagementMinor = 'Policy Management Minor',
  CustomerServices = 'Customer Services',
  ComplaintHandling = 'Complaint Handling'
}
